import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker, Descriptions, Image, Space, Table, Typography, Card, Flex } from 'antd';
import CustomerPicker from "components/pickers/customer"

import ImagePicker from "components/pickers/image/MultiImagePicker"
import DebtService from "services/debt"
import { useApp } from 'contexts/app';
import dayjs from 'dayjs';
import ComonFields from "./ComonFields"
import { formatDate, formatOnlyDate } from "utils/date"
import { formatCurrency } from "utils/number"
import { ExclamationCircleOutlined } from '@ant-design/icons';
import InputNumber from "components/input-number"

import _ from "lodash"
const { Title } = Typography;
const service = new DebtService();
const UpdateDebt = ({ onSaved, id, open = false, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { modal, showLoading } = useApp();

    const { showNotify } = useApp();
    const [data, setData] = useState({})
    const [orders, setOrders] = useState([]);
   

    useEffect(() => {
        if (open != isModalOpen) {
            setIsModalOpen(open)
        }
    }, [open])

    useEffect(() => {
        setData({})
        if (isModalOpen && id) {
            loadData();
        }
    }, [isModalOpen, id])
    const deleteDebt = async debtID => {
        showLoading(true);
        await service.delete(debtID);
        showLoading(false);
        onSaved();
    }
    const loadData = async () => {

        var item = await service.getByID(id);
        var lst = await service.getOrderForAllocation(id);
      
        setOrders(lst);

        if (item) {
            setData(item)
            setIsModalOpen(true);
        } else {

            setData({})
        }
    }


    useEffect(() => {
        if (!isModalOpen) {
            if (onClose)
                onClose()
        }
    }, [isModalOpen])

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onBntDeleteClick = async () => {
        modal.confirm({
            icon: <ExclamationCircleOutlined />,
            content: "Bạn chắc chắn muốn xoá thanh toán này",
            onOk: async () => {
                await deleteDebt(id);
                handleCancel();
            },
        })
    }

    const onOrderAllocationAmountChange = (id, amount) => {
        var order = orders.find(x => x.id == id);
        if (order) {
            order.allocation_amount = amount;
            setOrders([...orders]);
        }
    }


    const onBtnAllocationClick =  async() => {
        var lstAllocation = orders.map(x => {
            return {
                order_id: x.id,
                amount: x.allocation_amount ?? 0
            }
        })

        lstAllocation =  lstAllocation.filter(x=>x.amount >0);
  
        showLoading(true);
        await  service.allocation(id, lstAllocation);
        showLoading(false)
        onSaved();
        onClose();

    }


    const columns = [
        {
            title: 'Đơn hàng',

            render: (record) => {

                return (
                    <Space direction='vertical'>

                        <div>
                            {record.id}

                        </div>
                        <div>
                            {formatOnlyDate(record.create_on)}
                        </div>
                    </Space>
                )

            }
        },

        {
            title: 'Tổng tiền',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        {formatCurrency(record.total_amount)}
                    </Space>
                )

            }
        },

        {
            title: 'Đã thanh toán',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        {formatCurrency(record.paid_amount)}
                    </Space>
                )

            }
        },
        {
            title: 'Còn nợ',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        {formatCurrency(record.remain_amount)}


                    </Space>
                )

            }
        },

        {
            title: 'Phân bổ',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <InputNumber value={record.allocation_amount} onChange={e => onOrderAllocationAmountChange(record.id, e)}></InputNumber>


                    </Space>
                )

            }
        },











    ];



    return (
        <>

            <Modal
                title="Phân bổ thanh toán"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                width={"50%"}
                onCancel={handleCancel}
                footer={<Space>
                    <Button onClick={onBtnAllocationClick} type='primary'>Phân bổ</Button>
                    <Button onClick={handleCancel}>Close</Button>
                </Space>}
            >

                <Card title="Thông tin thanh toán">
                    <Descriptions column={2} >
                        <Descriptions.Item label="Số tiền">{formatCurrency(data.amount)}</Descriptions.Item>
                    </Descriptions>
                    <Flex justify='flex-end'>
                        <Space>
                            <Button type='primary'>Tự động phân bổ</Button>
                        </Space>
                    </Flex>
                </Card>



                <Space style={{ width: "100%" }} direction='vertical'>
                    <Title level={5}>Đơn hàng</Title>
                    <Table pagination={false} columns={columns} dataSource={orders}></Table>
                </Space>

            </Modal>
        </>
    );
};
export default UpdateDebt;